/**
 * @file index router
 * @author linliu21
 */
import Index from './index.vue'

export default {
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/snow/router.js